import { Machine } from 'xstate';

export const toggleMachine = Machine({
  id: 'toggle',
  initial: 'content',
  states: {
    content: {
      on: {
        SWITCH_COLLECTION_SELECT: 'collectionSelect',
        SWITCH_COLLECTION_EDITING: 'collectionEditing',
        SWITCH_CONTENT_MODE: 'content',
      }
    },
    collectionSelect: {
      on: {
        SWITCH_COLLECTION_SELECT: 'collectionSelect',
        SWITCH_COLLECTION_EDITING: 'collectionEditing',
        SWITCH_CONTENT_MODE: 'content',
      }
    },
    collectionEditing: {
      on: {
        SWITCH_COLLECTION_SELECT: 'collectionSelect',
        SWITCH_COLLECTION_EDITING: 'collectionEditing',
        SWITCH_CONTENT_MODE: 'content',
      }
    }
  }
});
